'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';

export default function ClientCookieBanner() {
    // Default to false so Server (Googlebot) sees NOTHING
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // 1. Check if we are in the browser
        if (typeof window === 'undefined') return;

        // 2. Logic: Timezone check + LocalStorage check
        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const exemptedTimezones = ['Asia/Tehran'];
        const consentGiven = localStorage.getItem('consentGiven');

        // Show banner ONLY if NOT in Iran AND NO choice made yet
        if (!exemptedTimezones.includes(userTimezone) && !consentGiven) {
            setShowBanner(true);
        }
    }, []);

    const updateConsent = (status: 'granted' | 'denied') => {
        // Safe GTM update

        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('consent', 'update', {
                ad_storage: status,
                analytics_storage: status,
                ad_user_data: status,
                ad_personalization: status,
            });
        }
        localStorage.setItem('consentGiven', status);
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div
            data-cookie-banner
            className='fixed bottom-0 left-0 right-0 z-[100] bg-white dark:bg-slate-900 border-t border-gray-200 dark:border-slate-800 p-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]'
        >
            <div className='max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4'>
                <div className='flex-1 text-sm text-gray-700 dark:text-gray-300'>
                    <p className='font-bold text-gray-900 dark:text-white mb-1'>
                        We value your privacy
                    </p>
                    <p>
                        We use cookies to enhance your browsing experience, serve personalized ads
                        or content, and analyze our traffic. By clicking &laquo;Accept All&raquo;,
                        you consent to our use of cookies. Read our{' '}
                        <Link
                            href='/privacy-policy'
                            className='underline text-blue-600 dark:text-blue-400 hover:text-blue-800'
                        >
                            Privacy Policy
                        </Link>
                        .
                    </p>
                </div>
                <div className='flex flex-shrink-0 gap-3'>
                    <button
                        onClick={() => updateConsent('denied')}
                        className='px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 dark:bg-slate-800 dark:text-gray-200 dark:hover:bg-slate-700'
                    >
                        Reject All
                    </button>
                    <button
                        onClick={() => updateConsent('granted')}
                        className='px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700'
                    >
                        Accept All
                    </button>
                </div>
            </div>
        </div>
    );
}
